import actionTypes from '../../actions/Contact/types';

export const initialState = {
  contact: [],
};

export default function RecommendationProductsReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case actionTypes.GET_CONTACT:
      return {
        ...state,
        contact: action.payload,
      };
    default:
      return state;
  }
}
